f = require 'effing'
valueUnion = require 'app/scripts/lib/util/value-union'
_ = require 'underscore'
Queries = require 'app/scripts/network/quick-queries'
{ track } = require '@trello/analytics'

module.exports = Payloads = {}

for key, query of Queries
  if _.isObject(query)
    Payloads[key] = { query }
  else if _.isString(query)
    Payloads[key] = query
  else
    throw new Error("Implicit coupling fell over")

orgBoardsMapping = (deltaBoards, model) ->
  idBoards = _.pluck deltaBoards, 'id'
  model.set('idBoards', idBoards)

Payloads.organizationBoardsPage.mappingRules =
  boards: orgBoardsMapping

attachmentsUnion = (deltaAttachments, model) ->
  currentAttachments = model.get('attachments') ? []
  newAttachments = valueUnion(f.get('id'), currentAttachments, deltaAttachments)
  model.set('attachments', newAttachments)

Payloads.currentBoardMinimal.mappingRules =
  attachments: attachmentsUnion

Payloads.currentBoardPluginData.mappingRules =
  attachments: attachmentsUnion

# Assumes that board.cards and board.lists are both included, that closed
# cards/lists are not included, that the cards have the idList and pos
# fields defined and that lists have the pos field defined
knownBoards = {}
deprioritizeHiddenCards = (board, modelCache) ->
  knownBoards[board.id] = true

  { cards, lists } = board

  # Hard coded list width
  maxVisibleLists = Math.max(3, Math.ceil(window.innerWidth / 270))

  _.sortBy(lists, 'pos').forEach (list, index) ->
    list._visible =
      index < maxVisibleLists ||
      # We don't want to delay loading cards for lists we already know about
      modelCache.get('List', list.id)?

  boardHasOrphanedCards = false

  listsById = _.indexBy(lists, 'id')
  cardsByList = _.chain(cards)
    .groupBy('idList')
    .values()
    .map (listCards) =>
      _.sortBy(listCards, 'pos').forEach (card, index) ->
        list = listsById[card.idList]
        if list?
          card._visible = list._visible
        else
          boardHasOrphanedCards = true
          card._visible = false
        return


  if boardHasOrphanedCards
    track("Error", "Orphaned Cards", board.id)

  listsByVisible = _.groupBy board.lists, '_visible'
  board.lists.forEach (list) -> delete list._visible

  cardsByVisible = _.groupBy board.cards, '_visible'
  board.cards.forEach (card) -> delete card._visible

  deferredBoard =
    id: board.id

  # NOTE: It makes a difference having the cards come before the lists
  # on the response and deferred response, we want the cards to be first
  # so they're already known when the list is initialized (and so they
  # aren't procesed as "adds" to the list's cardList)
  deferredBoard.cards = cardsByVisible[false] ? []
  deferredBoard.lists = listsByVisible[false] ? []

  board.cards = cardsByVisible[true] ? []
  board.lists = listsByVisible[true] ? []

  if deferredBoard.lists.length > 0 || deferredBoard.cards.length > 0
    { data: board, deferred: deferredBoard }
  else
    { data: board }

afterInitialLoad = (board) ->
  if knownBoards.hasOwnProperty(board.id)
    { data: board }
  else
    { deferred: board }

Payloads.currentBoardMinimal.splitDeferred = deprioritizeHiddenCards
Payloads.currentBoardPluginData.splitDeferred = afterInitialLoad
Payloads.currentBoardSecondary.splitDeferred = afterInitialLoad

Payloads.memberActions = [
  Payloads.boardActions
  'updateMember'
].join(',')

Payloads.boardFieldsUnread = [
  'dateLastActivity'
  'dateLastView'
]

Payloads.boardAttachment = query:
  structure: 'all',
  structure_limit: 5,
  fields: 'name,prefs,shortLink,url'

Payloads.boardFieldsMinimalMemberships = [
  'name'
  'closed'
  'memberships'
].join(',')

Payloads.organizationMembersBoardFields = [
  Payloads.boardFieldsMinimalMemberships
  'idOrganization',
  'prefs'
].join(',')

Payloads.enterpriseMemberFields = [
  'active'
  'avatarUrl'
  'confirmed'
  'enterpriseActiveOrgCount'
  'enterpriseDeactivatedOrgCount'
  'fullName'
  'initials'
  'memberType'
  'nonPublic'
  'roles'
  'userType'
  'username'
  'memberEmail'
  'dateLastAccessed'
].join(',')

Payloads.enterpriseMinimum =
  query:
    fields: 'name,displayName'

Payloads.enterprise =
  query:
    fields: 'displayName,name,prefs,products,organizationPrefs,pluginWhitelistingEnabled,idPluginsAllowed,idp,logoHash'

Payloads.enterpriseOrganizationFields = [
  'name'
  'displayName'
  'logoHash'
  'memberships'
].join(',')

Payloads.organizationFieldsMinimalMemberships = [
  Payloads.organizationFieldsMinimal
  'memberships'
]

Payloads.organizationFieldsMinimalMembershipsWithAvailableLicenseCount = [
  Payloads.organizationFieldsMinimalMemberships
  'availableLicenseCount'
]

Payloads.organizationFieldsMembersPage = [
  Payloads.organizationBoardsFields
  'memberships'
].join(',')

membershipUnion = (deltaMemberships, model) ->
  currentMemberships = model.get('memberships') ? []
  newMemberships = valueUnion(f.get('id'), currentMemberships, deltaMemberships)
  model.set('memberships', newMemberships)

Payloads.organizationFieldsMembersPageWithAvailableLicenseCount = [
  Payloads.organizationBoardsFields
  'availableLicenseCount'
].join(',')

Payloads.boardMinimal =
  query:
    fields: Payloads.boardFieldsMinimal
    organization: true
    organization_fields: Payloads.organizationFieldsMinimal
    myPermLevel: true
    memberships: 'me'
  mappingRules:
    memberships: membershipUnion

Payloads.boardChecklists = query:
  fields: ''
  cards: 'visible'
  card_fields: ''
  card_checklists: 'all'

Payloads.boardCompleter = query:
  fields: 'closed,idOrganization,name,url'

Payloads.boardsMenuMinimal =
  query:
    boards: 'open,starred'
    board_fields: Payloads.boardFieldsMinimal
    boardStars: true
    organizations: 'all'
    organization_fields: Payloads.organizationFieldsMinimal
    board_organization: true
    board_organization_fields: Payloads.organizationFieldsMinimal
    board_myPermLevel: true
    board_memberships: 'me'
  mappingRules:
    memberships: membershipUnion

Payloads.boardsMenu = query:
  fields: ''
  board_fields: Payloads.boardFieldsMinimal
  organizations: 'all'
  organization_fields: Payloads.organizationFieldsMinimal
  board_organization: true
  board_organization_fields: Payloads.organizationFieldsMinimal
  paid_account: true

Payloads.memberUnreadBoards = query:
  fields: ''
  boards: 'open,starred'
  board_fields: Payloads.boardFieldsUnread

Payloads.boardUnread = query:
  fields: Payloads.boardFieldsUnread

Payloads.canonicalCard = query:
  board: true
  board_fields: Payloads.boardFieldsMinimal
  customFields: true
  customFieldItems: true
  list: true

Payloads.cardDetails = query:
  actions: Payloads.cardActions
  actions_display: true
  action_memberCreator_fields: Payloads.memberFieldsAndPremOrgsAdmin
  action_reactions: true
  members: true
  member_fields: Payloads.memberFields
  attachments: true
  fields: 'email'
  checklists: 'all'
  checklist_fields: 'all'
  list: true
  pluginData: true
  customFieldItems: true

Payloads.cardAttachment = query:
  board: true
  members: true
  member_fields: Payloads.memberFields
  attachments: true
  fields: 'all'
  checklists: 'all'
  list: true
  pluginData: true
  customFields: true
  customFieldItems: true

Payloads.cardMinimal = query:
  fields: Payloads.cardFieldsBulk

Payloads.cardCompleter = query:
  fields: 'closed,idBoard,name,url'
  board: true
  board_fields: 'name'

Payloads.cardVoters = query:
  fields: 'idMembersVoted'
  membersVoted: true

Payloads.cardCopy = query:
  members: true
  member_fields: Payloads.memberFields
  attachments: true
  stickers: true
  fields: 'name'
  checklists: 'all'

Payloads.cardList = query:
  fields: 'all'

Payloads.customFields = query:
  fields: ''
  customFields: true
  cards: 'visible'
  card_customFieldItems: true
  card_fields: ''

Payloads.memberAccount = query:
  tokens: 'all'
  sessions: 'all'
  credentials: 'all'
  logins: true
  enterprises: true
  enterprise_fields: 'prefs'
  token_plugins: true

Payloads.memberBilling = query:
  paid_account: true
  credits: 'invitation,promoCode'
  organizations: 'all'
  organization_fields: 'displayName,name,prefs,products,url'
  organization_paid_account: true

Payloads.memberPaidAccount = query:
  paid_account: true

Payloads.orgMemberCards = query:
  board: true
  list: true
  fields: 'badges,closed,dateLastActivity,due,dueComplete,idAttachmentCover,idList,idBoard,idMembers,idShort,labels,name,url'
  attachments: 'true'
  members: 'true'
  stickers: 'all'
  member_fields: Payloads.memberFields
  board_fields: Payloads.boardFieldsMinimalMemberships

Payloads.memberCards =
  query:
    boards: 'open'
    board_fields: 'name,closed,idOrganization,prefs'
    board_lists: 'open'
    board_memberships: 'me'
    organizations: 'all'
    organization_fields: 'displayName,name,prefs,products,url'
    organization_memberships: 'me'
    organization_paid_account: true
    paid_account: true
  mappingRules:
    memberships: membershipUnion

Payloads.memberMinimal = query:
  fields: Payloads.memberFields

Payloads.memberProfile = query:
  actions: 'all'
  actions_limit: 10
  actions_display: true
  organizations: 'all'
  organization_fields: Payloads.organizationFieldsMinimal
  organization_paid_account: true
  boards: 'open'
  board_fields: 'name,prefs,idOrganization'
  paid_account: true

Payloads.memberProfile_daysBack = 30

Payloads.organization =
  query:
    boards: 'open'
    board_fields: Payloads.boardFieldsMinimal
    enterprise: true
    fields: 'all'
    members: 'all'
    member_fields: Payloads.memberFields
    membersInvited: 'all'
    membersInvited_fields: Payloads.memberFields
    paid_account: true
  mappingRules:
    boards: orgBoardsMapping

Payloads.organizationExports = query:
  exports: true
  fields: 'all'
  paid_account: true
  enterprise: true

Payloads.organizationPaidAccount = query:
  paid_account: true

Payloads.organizationMembers = query:
  fields: Payloads.organizationFieldsMembersPage
  members: 'all'
  member_fields: Payloads.memberFields
  member_activity: true
  membersInvited: 'all'
  membersInvited_fields: Payloads.memberFields
  paid_account: true
  enterprise: true
  tags: true

Payloads.organizationMembersWithAvailableLicenseCount = query:
  fields: Payloads.organizationFieldsMembersPageWithAvailableLicenseCount
  members: 'all'
  member_fields: Payloads.memberFields
  membersInvited: 'all'
  membersInvited_fields: Payloads.memberFields
  paid_account: true
  tags: true

Payloads.organizationMembersBoards =
  query:
    fields: ''
    boards: 'open'
    board_fields: Payloads.organizationMembersBoardFields
  mappingRules:
    boards: orgBoardsMapping

Payloads.organizationMembersCollaborators =
  query:
    fields: ''
    collaborators: true

Payloads.organizationMembersMinimal = query:
  members: 'all'
  fields: Payloads.organizationFieldsMinimalMemberships

Payloads.organizationAdminsMinimal = query:
  members: 'admins'
  fields: Payloads.organizationFieldsMinimalMemberships

Payloads.organizationFieldsMinimalWithAvailableLicenseCount = query:
  members: 'all'
  fields: Payloads.organizationFieldsMinimalMembershipsWithAvailableLicenseCount

Payloads.organizationFieldsMaximumAndAvailableLicenseCount = query:
  fields: [
    'availableLicenseCount',
    'maximumLicenseCount'
  ]

Payloads.organizationMinimal = query:
  fields: 'all'
  tags: true

Payloads.organizations = query:
  organizations: 'all'
  organization_paid_account: true

Payloads.organizationsWithoutBoards = query:
  organizations: 'all'
  organization_paid_account: true
  organization_fields: 'name,displayName,logoHash,products,memberships'
  fields: ''

Payloads.organizationsMemberships = query:
  organizations: 'all'
  organization_fields: 'memberships'

Payloads.organizationCredits = query:
  credits: 'all'
  fields: 'id'

Payloads.idCard = query:
  fields: ''
  checkItemStates: false

DefaultBoardFields = [
  'name'
  'desc'
  'descData'
  'closed'
  'idOrganization'
  'pinned'
  'url'
  'shortUrl'
  'prefs'
  'labelNames'
]
Payloads.cardsAndListsMinimal = query:
  lists: 'open'
  list_fields: 'name,pos,idBoard,closed,limits'
  cards: 'visible'
  card_fields: 'idList,idBoard,pos,closed'
  fields: [
    DefaultBoardFields...
    'limits'
  ].join(',')
Payloads.listsMinimal = query:
  lists: 'open'
  list_fields: 'name,pos,idBoard,closed'
  fields: 'limits'

Payloads.listMinimal = query:
  fields: 'name,pos,idBoard,closed'

Payloads.archivedLists = query:
  lists: 'closed'
  list_fields: 'name,pos,idBoard,closed'
  cards: 'open'
  card_fields: 'idList,idBoard,badges,pos,closed'

Payloads.action = query:
  display: true
  memberCreator: true

Payloads.bcFeatures = query:
  boards: 'open'
  board_fields: 'all'
  board_starCounts: 'organization'
  board_membershipCounts: 'active'
  fields: 'all'
  paid_account: true
  memberships: 'all'
  members: 'all'
  tags: true
  idBoardsMostActive: true

Payloads.memberOrganizationDeactivatedMembers =
  query:
    fields: Payloads.organizationFieldsMinimal
    memberships: 'deactivated'
  mappingRules:
    memberships: membershipUnion


Payloads.pendingOrganizations = mappingRules:
  # The `memberRequestor` field gets detected by ModelCache
  # as a nested Member model, and will be removed from the
  # returned models. This mapping rule is in place to just stick that
  # field back on the models.
  memberRequestor: (memberRequestor, model) ->
    model.set('memberRequestor', memberRequestor)
